import React, { useState, useEffect, useRef } from "react";
import "./Calls.css";
import url from "../../../Utility/URL/url";
import axios from "axios";
import { toast } from "react-toastify";
import CallsModal from "./CallsModal";
import Loader from "../../../Utility/loader/Loader";
import getUsernameFromSession from "../../../Utility/gettingInformation/getUsernameFromSession";
import authHeader from "../../../headerTokenUtility/auth.header";
import moment from "moment";
import { ReactComponent as PageNotFound } from "../../../Utility/ErrorPages/PageNotFound.svg";
function Calls() {
  const firstRender = useRef(true);
  const [selectedFilterCalls, setSelectedFilterCalls] = useState("Pending");
  const [openModal, setOpenModal] = useState(false);
  const [pendingCalls, setPendingCalls] = useState([]);
  const [completedCalls, setCompletedCalls] = useState([]);
  const [selectedCall, setSelectedCall] = useState(null);
  const [loading, setLoading] = useState(true);
  const [availability, setAvailability] = useState();
  const username = getUsernameFromSession();

  async function getAllCalls() {
    try {
      if (selectedFilterCalls === "Pending") {
        const pendingResponse = await axios.get(
          url.GET_PENDING_CALLS + username,
          {
            headers: authHeader(),
          }
        );
        if (pendingResponse.status === 200) {
          setPendingCalls(() => pendingResponse.data);
        }
      }

      if (selectedFilterCalls === "Completed") {
        const completedResponse = await axios.get(
          url.GET_COMPLETED_CALLS + username,
          {
            headers: authHeader(),
          }
        );
        if (completedResponse.status === 200) {
          setCompletedCalls(() => completedResponse.data);
        }
      }

      setLoading(() => false);
    } catch (error) {
      toast.warning("Technical Issue while fetching the data", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
  async function getAvailabilityHere() {
    try {

      let response = await axios.get(url.GET_AVAILABILITY_DETAILS + username, {
        headers: authHeader(),
      });

      setAvailability((currAvailability) =>
        currAvailability !== response.data ? response.data : currAvailability
      );
    } catch (error) {
      toast.warning("Technical Issue while fetching the data", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
  useEffect(() => {
    getAllCalls();
    getAvailabilityHere();

    return () => {
      //pending request will be canceled here/
    };
  }, []);
  function handleRescheduleApi(callDetails, details) {
    const { selectedTime, selectedDate } = details;

    const data = {
      ...callDetails,
      bookingTime: selectedTime,
      bookingDate: moment(selectedDate).format("YYYY-MM-DD"),
    };
    toast
      .promise(rescheduleCall(data), {
        pending: "Rescheduling Call",
        success: "Rescheduled Call successfully!",
        error: "Failed to Rescheduled the Call. Please try again later...",
      })
      .then((response) => {
        if (response.status === 200) {
          handleCloseModal();
          setLoading(() => true);
          getAllCalls();
        }
      });
  }
  function rescheduleCall(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(url.RESCHEDULE_CALL, data, {
          headers: authHeader(),
        });

        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  }
  function handleMarkAsComplete(callDetails) {
    axios
      .post(url.POST_MARK_AS_COMPLETED + callDetails.bookingId, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status === 200) {
          toast.success("Call completed successfully!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setSelectedCall(null);
          setOpenModal(false);
          setLoading(() => true);
          getAllCalls();
        }
      })
      .catch((error) => {
        toast.warning("Completion is not done yet something weird happend!", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }
  function handleOpenModal(call) {
    setSelectedCall(() => call);
    setOpenModal(() => true);
  }
  function handleCloseModal() {
    setSelectedCall(null);
    setOpenModal(false);
  }
  function getCallsListUI() {
    let calls;

    if (selectedFilterCalls === "Pending") {
      calls = pendingCalls;
    } else {
      calls = completedCalls;
    }

    return calls.length === 0 ? (
      <div className="container list-is-empty text-center">
        <div className="Image mt-5 pt-5">
          <PageNotFound height={"300px"} />
        </div>
        <h1 className="display-5 text-muted">Looks like nothing is here!!!</h1>
      </div>
    ) : (
      calls.map((call, index) => {
        return (
          <div
            className="p-0 "
            style={{
              // paddingLeft: "10px",
              // paddingRight: "25px",
            }}
            key={index}
          >
            <div className="calls-card">
              <div className=" row calls-header">
                <div className="d-flex col-lg-9 pr-0 align-items-center" style={{fontSize:"14px"}}>
                  <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 0 640 640" style={{marginTop:"-1px"}}><path fill="#0d0d0d" d="M528 320C528 434.9 434.9 528 320 528C205.1 528 112 434.9 112 320C112 205.1 205.1 112 320 112C434.9 112 528 205.1 528 320zM64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320zM296 184L296 320C296 328 300 335.5 306.7 340L402.7 404C413.7 411.4 428.6 408.4 436 397.3C443.4 386.2 440.4 371.4 429.3 364L344 307.2L344 184C344 170.7 333.3 160 320 160C306.7 160 296 170.7 296 184z" style={{marginTop:"-2px"}}/></svg>
                  {formatDate(call.bookingDate)}{" "}
                  {formatBookingTime(call.bookingTime, call.callDuration)}
                </div>
                <div className="col-lg-3 text-end">
  {selectedFilterCalls === "Pending" ? (
    call.bookingState === "NO_SHOW" ? (
      <span className="badge rounded-pill d-inline-flex align-items-center gap-2" style={{ backgroundColor: "#fee2e2", color: "#ff2768", padding:"6px 14px" }}>
        <span
          style={{
            width: "5px",
            height: "5px",
            borderRadius: "50%",
            backgroundColor: "#ff2768",
            display: "inline-block",
          }}
        ></span>
        No Show
      </span>
    ) : (
      <span className="badge rounded-pill d-inline-flex align-items-center gap-1" style={{ backgroundColor: "#fee2e2", color: "#ff2768", padding:"6px 14px"  }}>
        <span
          style={{
            width: "5px",
            height: "5px",
            borderRadius: "50%",
            backgroundColor: "#ff2768",
            display: "inline-block",
          }}
        ></span>
        Pending
      </span>
    )
  ) : call.bookingState === "BOOKING_CANCELED" ? (
    <span className="badge rounded-pill d-inline-flex align-items-center gap-1" style={{ backgroundColor: "#fee2e2", color: "#ff2768", padding:"6px 14px" }}>
      <span
        style={{
          width: "5px",
          height: "5px",
          borderRadius: "50%",
          backgroundColor: "#ff2768",
          display: "inline-block",
        }}
      ></span>
      Declined
    </span>
  ) : (
    <span className="badge rounded-pill d-inline-flex align-items-center gap-2" style={{ backgroundColor: "#dcfce7", color: "#15803d" }}>
      <span
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: "#15803d",
          display: "inline-block",
        }}
      ></span>
      Success
    </span>
  )}
</div>

              </div>
              <div className="row calls-content">
                <div className="col-lg-12">
                  <div className="fs-5">{call.title}</div>
                  <div className="title">{call.callDuration} mins session with <span>{call.cxName}</span></div>
                </div>
              </div>
              <div className=" calls-footer d-flex gap-3">
                <div className="">
                  <button
                    className="d-flex align-items-center justify-content-center btn btn-sm" style={{background: "#eeeeee", border:"none", color:"#545454", padding:"6px 12px", border:"1px solid #d1d1d1"}}
                    onClick={(event) => {
                      handleOpenModal(call);
                    }}
                  >
                     <svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 640 640" style={{ marginRight: "5px" }}><path fill="#545454" d="M320 112C434.9 112 528 205.1 528 320C528 434.9 434.9 528 320 528C205.1 528 112 434.9 112 320C112 205.1 205.1 112 320 112zM320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM280 400C266.7 400 256 410.7 256 424C256 437.3 266.7 448 280 448L360 448C373.3 448 384 437.3 384 424C384 410.7 373.3 400 360 400L352 400L352 312C352 298.7 341.3 288 328 288L280 288C266.7 288 256 298.7 256 312C256 325.3 266.7 336 280 336L304 336L304 400L280 400zM320 256C337.7 256 352 241.7 352 224C352 206.3 337.7 192 320 192C302.3 192 288 206.3 288 224C288 241.7 302.3 256 320 256z"/></svg> Details
                  </button>
                </div>
              {!call.isCompleted && (
  <div className=" ">
     {call.callLinkForAdvisor ? (
    <button
      className="d-flex btn btn-sm align-items-center justify-content-center join-call-btn"
      style={{ backgroundColor: "#00bf63", color: "#fff", border: "none", padding:"6px 12px" }} onClick={() => window.open(call.callLinkForAdvisor, "_blank")}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="20px"
        viewBox="0 0 640 640"
        style={{ marginRight: "5px" }}
      >
        <path
          fill="#f7f7f7"
          d="M128 128C92.7 128 64 156.7 64 192L64 448C64 483.3 92.7 512 128 512L384 512C419.3 512 448 483.3 448 448L448 192C448 156.7 419.3 128 384 128L128 128zM496 400L569.5 458.8C573.7 462.2 578.9 464 584.3 464C597.4 464 608 453.4 608 440.3L608 199.7C608 186.6 597.4 176 584.3 176C578.9 176 573.7 177.8 569.5 181.2L496 240L496 400z"
        />
      </svg>
      Join call
    </button>
     ) : (
    <span className="text-muted">No Link Available</span>
  )}
  </div>
)}

              </div>
            </div>
          </div>
        );
      })
    );
  }
  async function handleDeclineCall(bookingId, reason) {
    try {
      await axios.delete(url.DELETE_CALL_SERVICE + bookingId, {
        headers: authHeader(),
      });

      toast.error("Call Declined!", {
        position: toast.POSITION.TOP_RIGHT,
      });

      handleCloseModal();
      getAllCalls();
      getAvailabilityHere();
    } catch (error) {
      toast.warning("Call is not declined.. Please try again later !");
    }
  }
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    getAllCalls();
  }, [selectedFilterCalls]);
  function formatBookingTime(bookingTime, callDuration) {
    const [time, period] = bookingTime.split(" ");
    const [hours, minutes] = time.split(":");

    let formattedHours = Number(hours);
    const formattedMinutes = Number(minutes);

    if (period.toLowerCase() === "pm" && formattedHours < 12) {
      formattedHours += 12;
    }

    const start = new Date();
    start.setHours(formattedHours);
    start.setMinutes(formattedMinutes);

    const end = new Date(start.getTime() + callDuration * 60000);

    const formattedStartTime = formatTime(start.getHours(), start.getMinutes());
    const formattedEndTime = formatTime(end.getHours(), end.getMinutes());
    const formattedBookingTime = `${formattedStartTime} - ${formattedEndTime}`;

    return formattedBookingTime;
  }

  function formatTime(hours, minutes) {
    let formattedHours = hours % 12;
    if (formattedHours === 0) {
      formattedHours = 12;
    }

    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedHoursWithLeadingZero =
      formattedHours < 10 ? `0${formattedHours}` : `${formattedHours}`;
    const period = hours < 12 ? "am" : "pm";

    return `${formattedHoursWithLeadingZero}:${formattedMinutes} ${period}`;
  }

  function formatDate(dateString) {
    // Create a new Date object using the input dateString
    const date = new Date(dateString);

    // Define the day names and month names
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Get the day, date, and month from the date object
    const dayName = days[date.getDay()];
    const dateNumber = date.getDate();
    const monthName = months[date.getMonth()];

    // Construct the formatted date string
    const formattedDate = `${dayName}, ${dateNumber} ${monthName}`;

    // Return the formatted date
    return formattedDate;
  }

  return (
    <div className="calls">
      <div className="header ">
        <div className="header-title d-flex flex-row">
          <p className="text-start fs-3 fw-bold " style={{padding:"10px 0"}}>Calls</p>
        </div>
      </div>
      
      <div className="main">
        {loading ? (
          <Loader />
        ) : (
          <div className="bookings">
            <div>
              <div>
              <div className="tab-container">
  <div
    className="tab-navigation"
    style={{
      borderTop: "1px solid rgb(229, 231, 235)",
      borderBottom: "1px solid rgb(229, 231, 235)",
    }}
  >
    <ul className="nav nav-tabs justify-content-start gap-3 px-3 m-0 py-0">
      <li className="nav-item p-0">
        <a
          className={`nav-link   ${
            selectedFilterCalls === "Pending" ? "active" : ""
          }`}
          onClick={() => setSelectedFilterCalls("Pending")}
          style={{ cursor: "pointer",  }}
        >
          Pending
        </a>
      </li>

      <li className="nav-item p-0">
        <a
          className={`nav-link  ${
            selectedFilterCalls === "Completed" ? "active" : ""
          }`}
          onClick={() => setSelectedFilterCalls("Completed")}
          style={{ cursor: "pointer",  }}
        >
          Completed
        </a>
      </li>
    </ul>
  </div>

  {(pendingCalls?.length > 0 || completedCalls?.length > 0) ? (
    <div className="tab-content-holder px-4">
      <div className="tab-content">
        <div className="row calls-main" style={{display:"grid", gap:"10px", gridTemplateColumns:"repeat(auto-fit, minmax(394px, 1fr))",}}>
          {/* Map loop here for calls card */}
          {getCallsListUI()}
        </div>
      </div>
    </div>
  ) : (
    <div className="text-center py-4 text-muted">No calls available</div>
  )}
</div>

              </div>
            </div>
          </div>
        )}

        {openModal && selectedCall !== null && (
          <CallsModal
            callDetails={selectedCall}
            closeModal={handleCloseModal}
            dateString={formatDate(selectedCall.bookingDate)}
            bookingTime={formatBookingTime(
              selectedCall.bookingTime,
              selectedCall.callDuration
            )}
            markAsComplete={handleMarkAsComplete}
            availability={availability}
            declineCall={handleDeclineCall}
            reschedule={handleRescheduleApi}
          />
        )}
      </div>
    </div>
  );
}

export default Calls;
